<template>
  <div class="row" :class="errorClass">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-group clearfix">
        <textarea
          class="form-control"
          v-model="textAreaInput"
          type="text"
          v-on:change="emitContent()"
          :required="isRequired"
        ></textarea>
      </div>
      <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        Please complete this field
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'errorClass'
  ],
  data () {
    return {
      textAreaInput: ''
    }
  },
  methods: {
    emitContent: function () {
      this.$emit('addedTextAreaInputContent', {label: this.label, content: this.textAreaInput, validated: this.textAreaInput.length > 0})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldTextArea.vue